import { render, staticRenderFns } from "./comingsoon_simple.vue?vue&type=template&id=354d6530&"
import script from "./comingsoon_simple.vue?vue&type=script&lang=js&"
export * from "./comingsoon_simple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports